import axios from "./axios-config";

export const getAllDiscounts = async (keyword, page) => {

    let { data } = await axios.get(`/super-admin/discounts?keywords=${keyword ?? ""}&page=${page}`)
    return (data);

}
export const getAllUsedDiscountsUsers = async () => {

    let { data } = await axios.get(`/super-admin/discounts/use/users`)
    return (data);

}

export const getSingleDiscount = async (id) => {

    let { data } = await axios.get(`/super-admin/discounts/` + id)
    return data;

}
export const deleteSingleDiscount = async (id) => {
    let { data } = await axios.delete(`/super-admin/discounts/` + id)
    return data;
}

export const updateSingleDiscounts = async (updateData) => {

    let { data } = await axios.post(`/super-admin/discounts/${updateData.id}?_method=put`, updateData.data)
    return data;
}

export const storeSingleDiscounts = async (storeData) => {

    let { data } = await axios.post(`/super-admin/discounts`, storeData)
    return data
}


// export const getDiscontDiscounts = async (data) => {
//     let { data } =  await axios.post(`/super-admin/Discounts/all/blogs`, data)
//     return data;
// }

// export const getWorkshopDiscounts = async (data) => {
//     try {
//         let response = await axios.post(`/super-admin/Discounts/all/discounts`, data)
//         return (response.data);
//     } catch (error) {
//         return (error);
//     }
// }

